<div class="menu-container" [class.is-execute-ia]="isExecuteIaUser">
    <div class="search">
        <div class="border">
            <p-field-outline-text
                class="p-menu-input"
                [(ngModel)]="searchText"
                [isSearch]="true"
                [isPrefixIcon]="true"
                [autoFocus]="true"
                (search)="onSearch($event)"
                [isServerSideSearch]="true"
                (keydown.arrowdown)="focusElemList()"
            ></p-field-outline-text>
            <p-icon class="x" name="x" (click)="closed.emit()" [attr.automation-id]="'CloseSearchMasthead'"></p-icon>
        </div>
    </div>
    <div class="menu">
        <div class="title p-headline-6">{{ 'Layouts.Masthead.RECENTLY_VIEWED_ITEMS.header' | translate }}</div>
        <mat-selection-list [multiple]="false" [hideSingleSelectionIndicator]="true" #optionsList="matSelectionList">
            <mat-list-option *ngFor="let item of recently$ | async" (keydown.enter)="navigate(item.url)">
                <p-recently-viewed-item [data]="item" (closed)="closed.emit()"></p-recently-viewed-item>
            </mat-list-option>
        </mat-selection-list>
    </div>
</div>
